import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { getCompanyLogo, htmlParser } from '../../../utils/utilFunctions';

const RenderLogo = props => {
  const { logoDirectoryPath, company, logoDataLocator } = props;
  const [isImageHidden, hideCompanyImageOnError] = useState(false);
  const srcLogo = getCompanyLogo(logoDirectoryPath, htmlParser(company));
  return (
    company &&
    logoDirectoryPath &&
    !isImageHidden && (
      <img
        src={srcLogo}
        alt={htmlParser(company)}
        className="logo"
        data-locator={logoDataLocator}
        onError={() => hideCompanyImageOnError(true)}
      />
    )
  );
};

RenderLogo.propTypes = {
  logoDirectoryPath: PropTypes.string,
  company: PropTypes.string,
  logoDataLocator: PropTypes.string,
};

RenderLogo.defaultProps = {
  logoDirectoryPath: '',
  company: '',
  logoDataLocator: '',
};
export default RenderLogo;
